export const environment = {
  production: true,
  name: 'production',
  API_ENDPOINT: '/api',
  API_BASE_PATH: 'https://api.mytricosystem.it',
};
